var heading_default = {
  "fontElementMap": "G9idD",
  "elementSpacing": "-Zd7o",
  "headerOne": "KK8yi -Zd7o",
  "headerTwo": "BEd2d -Zd7o",
  "headerThree": "NZDjz -Zd7o",
  "headerFour": "_5Iq-c -Zd7o",
  "headerFive": "WX-Mx -Zd7o",
  "headerSix": "_2GOPY -Zd7o",
  "child": "Wjt42"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
